import { atom } from 'jotai';

// Current registry project (ProjectDTO) and selected language sub-project, synced from route context
export const projectAtom = atom(null);
export const subProjectAtom = atom(null);

// Derived: the flow_uid MCP servers are scoped by (the selected language's flow)
export const flowUidAtom = atom((get) => get(subProjectAtom)?.flowUid || "");

// Stores the list of all MCP servers from context
export const serversAtom = atom([]);

// Stores the currently selected server for the right panel
export const selectedServerAtom = atom(null);

// Search query for filtering servers
export const searchQueryAtom = atom('');

// Status filter: 'All', 'Active', or 'Inactive'
export const statusFilterAtom = atom('All');

// Tab selection: 'tools' or 'prompts'
export const selectedTabAtom = atom('tools');

// Loading state
export const mcpLoadingAtom = atom(false);

// Error state
export const errorAtom = atom(null);
